/* eslint-disable no-console */

import { register } from 'register-service-worker'
import iziToast from "izitoast";

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    offline() {
      iziToast.show({
        class: 'iziToast-Map',
        rtl: true,
        theme: 'dark',
        title: 'آفلاین هستید!',
        message: 'لطفا از اتصال اینترنت خود مطمئن شوید.',
        position: 'bottomRight',
        transitionIn: 'fadeInUp',
        transitionOut: 'fadeOutDown',
        drag: false,
        progressBarColor: '#ffffff',
        iconColor: '#6c63ff',
        timeout: 6000,
        close: false
      });
    },
    error(error) {
      console.error('Service worker registration failed:', error);
    }
  })
}
